var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRpmMonitor1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_1",
    "data-name": 1,
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 20,
    viewBox: "0 0 13 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3859",
    "data-name": "Path 3859",
    d: "M13,20H10.35a1.305,1.305,0,0,1-1.27-1.02L6.47,6.96,3.92,18.83a1.3,1.3,0,0,1-1.27,1.02H0V17.26H1.6L5.06,1.16A1.441,1.441,0,0,1,6.47,0a1.423,1.423,0,0,1,1.4,1.15L11.4,17.4H13Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRpmMonitor1);
export default __webpack_public_path__ + "static/media/rpm_monitor_1.5770fda62a7005ebdaf00db66bef5198.svg";
export { ForwardRef as ReactComponent };